import React from 'react';

import classnames from 'classnames';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import DoubleArrowIcon from 'app/images/icons/double-arrow.svg';

interface IDynamicRightBarProps {
  children: React.ReactNode;
}

interface IDynamicRightBarState {
  expanded: boolean;
}

export default class DynamicRightBar extends React.Component<IDynamicRightBarProps, IDynamicRightBarState> {
  static defaultProps: IDynamicRightBarProps = {
    children: undefined,
  };

  state = {
    expanded: false,
  }

  handleToggleExpand = (): void => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  }

  render(): React.ReactNode {
    return (
      <div className={classnames({ expanded: this.state.expanded }, 'dynamic-right-bar')}>
        <div className="right-bar-expander" onClick={this.handleToggleExpand}>
          <Isvg className="expander-icon" src={DoubleArrowIcon} />
        </div>
        <div className="right-bar-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}
